import React, { PropsWithChildren, useMemo, useState } from 'react';
import CRMCustomHeaderContext from './CRMCustomHeaderContext';

const CRMCustomHeaderProvider: React.FunctionComponent<PropsWithChildren> = function ({
    children,
}) {
    const [isCRMPrescripteurPath, setIsCRMPrescripteurPath] = useState(false);
    const [offerName, setOfferName] = useState<string | undefined>(undefined);

    const contextValue = useMemo(
        () => ({
            isCRMPrescripteurPath,
            setIsCRMPrescripteurPath,
            offerName,
            setOfferName,
        }),
        [isCRMPrescripteurPath, offerName],
    );

    return (
        <CRMCustomHeaderContext.Provider value={contextValue}>
            {children}
        </CRMCustomHeaderContext.Provider>
    );
};

export default CRMCustomHeaderProvider;
